import {
  GetComplaintDetails,
  GetComplaintDetailsByComponent,
  GetComplaintDetailsBySupplier,
  GetKPIDetails,
} from "../../Redux/APIs/api_Complaint";
import Button from "@material-ui/core/Button";
import { useSelector, useDispatch } from "react-redux";
import MaterialTable from "material-table";
import { GetInspection } from "../../Redux/APIs/api_Pdir";
import { useEffect, useRef, useState } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import {
  BootstrapInput,
  tableIcons,
  baseApiURL,
} from "../../Utilities/Utility";
import { getSupplierEmailResult } from "../../Redux/APIs/api_view";
import { useNavigate } from "react-router-dom";

export default function ViewInspection() {
  const navigate = useNavigate();
  const tableRef = useRef();
  const [isLoader, setIsLoader] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [partId, setPartId] = useState("");
  const [reportName, setReportName] = useState("");
  const [inspectionNumber, setInspectionNumber] = useState("");
  const token = useSelector((state) => state.saveTokenReducer.token);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const siteToken = useSelector((state) => state.saveBearerTokenReducer);
  const azureToken = useSelector((state) => state.saveTokenReducer);
  const UID = useSelector((state) => state.saveUserIdReducer);
  const [sqmResp, setSQMResp] = useState(null);
  const [kpiData, setKpiData] = useState([]);
  const tableHeaderStyle = {
    backgroundColor: "var(--light-sand)",
    color: "var(--dark-blue)",
  };
  const tableOptions = {
    headerStyle: tableHeaderStyle,
    showTitle: false,
    draggable: false,
    pageSize: 5,
    pageSizeOptions: [5, 10, 25, 50],
    paginationPosition: "bottom",
    maxBodyHeight: "600px",
  };
  const handleSQMRespChange = (e) => {
    setSQMResp(e.target.value);
  };

  const [formData, setFormData] = useState({
    inspectionNumber: "",
    partNo: "",
    reportName: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const [dateInputs, setDateInputs] = useState({
    fromDate: "",
    toDate: "",
  });
  function handleDateChange(event, value) {
    let elem = event.target.name;
    switch (elem) {
      case "fromDate":
        setDateInputs({
          ...dateInputs,
          fromDate: event.target.value,
        });
        break;
      case "toDate":
        setDateInputs({
          ...dateInputs,
          toDate: event.target.value,
        });
        break;
      default:
        break;
    }
  }

  const [supplierName, setSupplierName] = useState(null);
  const handleSupplierNameChange = (e) => {
    setSupplierName(e.target.value);
  };

  useEffect(() => {
    console.log("userdetail", userDetails);
    //getKPIData();
    getSuppObj();
    getTableData();
  }, []);

  const navigateToAddInspection = (rowData) => {
    navigate("/addInspection", { state: rowData });
  };

  var columns = [
    {
      title: "Inspection Number.",
      field: "inspectionNumber",
      render: (rowData) => (
        <Button
          variant="contained"
          onClick={() => navigateToAddInspection(rowData)}
          sx={{
            backgroundColor: "#1976d2 !important",
            color: "#ffffff !important",
            boxShadow: "none !important",
            textTransform: "none",
            minWidth: "120px",
            "&:hover": {
              backgroundColor: "#115293 !important",
            },
          }}
        >
          {rowData.inspectionNumber}
        </Button>
      ),
    },

    // {
    //     title: "Supplier Code",
    //     field: "code",

    // },
    // {
    //     title: "Supplier Id",
    //     field: "supplierId",
    // },
    {
      title: "Report Name",
      field: "reportName",
      //render: (rowData) => <span>{rowData.sqmResponsible?.userEmail ?? "-"}</span>
    },
    {
      title: "Supplier Name",
      field: "supplierName",
      //render: (rowData) => <span>{rowData.sqmResponsible?.userEmail ?? "-"}</span>
    },
    // {
    //     title: "Commodity",
    //     field: "commodity",
    // },
    {
      title: "Part Number",
      field: "partNo",
    },
    {
      title: "Part Description",
      field: "description",
    },
    // {
    //     title: "Product Type",
    //     field: "productType",

    // },
    // {
    //     title: "Final decision",
    //     field: "finalDecision",
    // },
    // {
    //     title: "Observation",
    //     field: "observation",

    // },
    {
      title: "Status",
      field: "statusName",
    },

    {
      title: "Created Date",
      field: "createdDate",
      render: (rowData) => {
        if (!rowData.createdDate) return "";
        const date = new Date(rowData.createdDate);
        // format: YYYY-MM-DD
        return date.toISOString().split("T")[0];
      },
    },
  ];

  const [tableData, setTableData] = useState([]);
  function getTableData() {
    setIsLoader(true);
    GetInspection(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setTableData(response.objResult);
        setOriginalData(response.objResult);
        console.log("getdata", response.objResult);
        response.objResult.forEach((item, index) => {
          console.log(`Item ${index}:`, item.inspectionNumber, item.reportName);
          setInspectionNumber(item.inspectionNumber);
          setReportName(item.reportName);
        });
        setIsLoader(false);
      })
      .catch((error) => {
        //handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }

  const handleSearch = async () => {
    try {
      setIsLoader(true);

      const body = {
        UserId: userDetails.userId,
        FromDate: dateInputs?.fromDate || null,
        ToDate: dateInputs?.toDate || null,
        PartId: null,
        ReportName: formData?.reportName || null,
        InspectionNumber: formData?.inspectionNumber || null,
      };

      const res = await fetch(`${baseApiURL}/PDIR/SearchInspectionDetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + siteToken.token,
          AzureToken: azureToken.token,
          userId: UID.id,
          UserEmail: userDetails.userEmail,
          RoleName: userDetails.role,
          Gid: userDetails.gid,
          Roleid: userDetails.roleId,
        },
        body: JSON.stringify(body),
      });

      const data = await res.json();
      setTableData(data?.result?.objResult || []);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoader(false);
    }
  };

  const handleReset = () => {
    setDateInputs({ fromDate: "", toDate: "" });
    setFormData((prev) => ({
      ...prev,
      inspectionNumber: "",
      partNo: "",
      reportName: "",
    }));
    setTableData(originalData);
  };

  const [supplierEmailFilterObj, setSupplierEmailFilterObj] = useState([]);
  function getSuppObj() {
    getSupplierEmailResult(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        setSupplierEmailFilterObj(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  return (
    <>
          <Grid item xs={12} className="left-div">
              <h3 className="heading">Edit List of Inspection Report</h3>
          </Grid>
          <Grid container className="bg-card" spacing={2} style={{ marginTop:'10px' }}>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              From Date
            </InputLabel>
            <BootstrapInput
              type="date"
              id="bootstrap-input"
              name="fromDate"
              onChange={handleDateChange}
              value={dateInputs.fromDate}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              To Date
            </InputLabel>
            <BootstrapInput
              type="date"
              id="bootstrap-input"
              name="toDate"
              onChange={handleDateChange}
              value={dateInputs.toDate}
              // inputProps={{ max: getTodayDateMoment }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              Inspection No
            </InputLabel>

            <BootstrapInput
              type="text"
              id="bootstrap-input"
              name="inspectionNumber"
              value={formData.inspectionNumber || ""}
              onChange={handleChange}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth>
            <InputLabel shrink htmlFor="bootstrap-input">
              Report Name
            </InputLabel>

            <BootstrapInput
              type="text"
              id="bootstrap-input"
              name="reportName"
              value={formData.reportName || ""}
              onChange={handleChange}
            />
          </FormControl>
        </Grid>

        <Grid item className="mr-btm" xs={12} sm={6} md={2}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 16,
            }}
          >
            <Button
              className="pt-button--primary button-submit"
              variant="contained"
              onClick={handleSearch}
            >
              Filter Result
            </Button>
            <Button
              className="pt-button--primary button-submit"
              variant="contained"
              onClick={handleReset}
            >
              Reset
            </Button>
          </div>
        </Grid>
      </Grid>
      <Grid container className="bg-card" spacing={2}>
        <Grid item xs={12} className="matTable" style={{ marginTop: "15px" }}>
          <MaterialTable
            tableRef={tableRef}
            //actions={actions}
            columns={columns}
            data={tableData}
            icons={tableIcons}
            isLoading={isLoader}
            options={tableOptions}
          />
        </Grid>
      </Grid>
    </>
  );
}
